import React, { Component } from 'react';
import { noop, isEmpty } from 'lodash';
import axios from 'axios';
import classNames from 'classnames';

import ReactSelect from 'react-select';

import Request from '../../Framework/API/Request';

import './FileUploadField.scss';

import FileInput from 'react-file-input';
import Loading from '../../Dashboard/Components/Loading/Loading';
import CustomSelect from '../../Dashboard/Components/CustomSelect/CustomSelect';
import { create as createElement } from '../../Elements/Actions/ElementListActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const SELECT_STATE = {
  value: 'select',
  label: 'Select From Library',
  icon: 'ti-gallery',
};
const UPLOAD_STATE = {
  value: 'upload',
  label: 'Upload From Desktop',
  icon: 'ti-desktop',
};

const FILES_API_URL = '/api/v1/files';
const AUDIO_FILES_API_URL = '/api/v1/files/music';
const SERVER_URL = 'https://tca-image-uploads.s3.amazonaws.com';

const FORMATS = '.png, .gif, .jpeg, .jpg, .mp3, .wav, .avi, .mpeg, .mp4, .webm';
const MAX_SIZE = 5;

const getExtension = (src) => /(?:\.([^.]+))?$/.exec(src)[1];

const endsWith = (str = '', suffix) => str.toLowerCase().indexOf(suffix, str.length - suffix.length) !== -1;

export const isAudio = (str) => endsWith(str, '.mp3') || endsWith(str, '.wav');
export const isVideo = (str) =>
  endsWith(str, '.avi') || endsWith(str, '.mpeg') || endsWith(str, '.mp4') || endsWith(str, '.webm');

export const isPicture = (str) =>
  endsWith(str, '.jpeg') || endsWith(str, '.png') || endsWith(str, '.jpg') || endsWith(str, '.gif');

export const renderFile = (src = '') => {
  if (isVideo(src)) {
    return <video style={{ width: `100%` }} controls src={src} />;
  }

  if (isAudio(src)) {
    return <audio style={{ width: `100%` }} controls src={src} />;
  }

  if (isPicture(src)) {
    return <img src={src} style={{ width: `auto`, height: `100%` }} />;
  }

  return <div>Unsupported file type ".{getExtension(src)}"</div>;
};

class FileUploadField extends Component {
  constructor() {
    super();

    this.onActionChange = this.onActionChange.bind(this);
    this.toggleUploadMode = this.toggleUploadMode.bind(this);

    this.onFileChoosen = this.onFileChoosen.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.selectFile = this.selectFile.bind(this);
    this.onRemoveImage = this.onRemoveImage.bind(this);
    this.renderOption = this.renderOption.bind(this);
    this.onChangeFiles = this.onChangeFiles.bind(this);
    this.getFoldersDetail = this.getFoldersDetail.bind(this);
    this.onCloseShowFolder = this.onCloseShowFolder.bind(this);
    this.deleteFolders = this.deleteFolders.bind(this);
    this.createFolders = this.create.bind(this);
    this.updateFolder = this.updateFolder.bind(this);
    this.updateNameFolder = this.updateNameFolder.bind(this);
    this.toggleShowMode = this.toggleShowMode.bind(this);

    this.state = {
      loading: false,
      uploading: false,
      action: null,
      files: null,
      fileName: '',
      forceUpdateFiles: false,
      folder: [],
      showFolder: false,
      listFile: [],
      show: false,
    };
  }

  componentDidMount() {
    if (!isEmpty(this.props.input.value)) {
      this.setState({ action: UPLOAD_STATE });
      this.setState({ fileName: this.props.input.value });
    }
  }

  isUploading() {
    return this.state.uploading;
  }

  resetState = (fileName) => {
    this.setState({ fileName: fileName });
    this.getFiles(fileName);
  };

  onFileChoosen(e) {
    const files = e.target.files;
    if (!files.length) return;

    this.setLoading(true);
    Request.upload(`/api/v1/files/upload`, files)
      .then(({ data }) => {
        this.setLoading(false);
        this.toggleUploadMode();
        this.props.input.onChange(data.url);
        this.setState({ fileName: data.url });
      })
      .catch((err) => {
        this.setLoading(false);
      });
  }
  create(elementData) {
    this.setLoading(true);
    return axios
      .post(`/api/v1/elements/`, elementData)
      .then((res) => res.data)
      .then((data) => {
        this.setLoading(false);
        this.toggleUploadMode();
        this.setState({ action: SELECT_STATE, show: true });
        this.getFolders();
        this.getFiles();
      })
      .catch((err) => {
        this.setLoading(false);
      });
  }
  updateNameFolder(id, elementData) {
    this.setLoading(true);
    return axios
      .put(`/api/v1/elements/folders/${id}`, elementData)
      .then((res) => res.data)
      .then((data) => {
        this.getFolders();
        this.setLoading(false);
      })
      .catch((err) => {
        this.setLoading(false);
      });
  }

  updateFolder(id, elementData, isRemove = false, folder = false) {
    this.setLoading(true);
    this.getFoldersDetail(id).then(() => {
      let media = this.state.listFile[0].media;
      if (isRemove) {
        if (typeof media !== 'string') {
          media.map((item, i) => {
            const value = item.url ? item.url : item;
            if (value === elementData.url) {
              media.splice(i, 1);
            }
          });
        } else {
          media = [];
        }
      } else {
        if (typeof media !== 'string') {
          media.push(elementData);
        } else {
          media = [media, elementData];
        }
      }
      const data = {
        ...this.state.listFile[0],
        media: media,
      };
      return axios
        .put(`/api/v1/elements/${data.id}`, data)
        .then((res) => res.data)
        .then((data) => {
          if (!folder) {
            this.onRemoveImage(elementData.id);
            this.getFolders();
          } else {
            if (isRemove) {
              this.getFoldersDetail(id);
            }
          }
          this.setLoading(false);
        })
        .catch((err) => {
          this.setLoading(false);
        });
    });
  }
  getFolders = () => {
    this.setLoading(true);
    return axios
      .get(`/api/v1/elements/folders?q=`)
      .then((res) => res.data)
      .then((data) => {
        this.setLoading(false);
        this.setState({
          folder: data,
        });
      })
      .catch((err) => {
        this.setLoading(false);
      });
  };
  getFoldersDetail(id) {
    this.setLoading(true);
    return axios
      .get(`/api/v1/elements/folders/${id}`)
      .then((res) => res.data)
      .then((data) => {
        this.setState({ showFolder: true, listFile: data });
        this.setLoading(false);
      })
      .catch((err) => {
        this.setLoading(false);
      });
  }
  deleteFolders = (id) => {
    return axios
      .delete(`/api/v1/elements/folders/delete/${id}`)
      .then((res) => res.data)
      .then((data) => {
        this.getFolders();
      })
      .catch((err) => {});
  };
  onFolderChoosen(e, titleEn) {
    const files = e.target.files;
    if (!files.length) return;

    this.setLoading(true);
    Request.upload(`/api/v1/files/upload-multi`, files)
      .then(({ data }) => {
        const _data = {
          folderType: 'new',
          titleEn: titleEn,
          newFolderName: titleEn,
          media: data.fileData,
        };
        this.create(_data);
      })
      .catch((err) => {});
  }
  onRemoveImage(id) {
    this.setLoading(true);
    if (true) {
      this.setState({ fileName: '' });
      this.props.input.onChange('');
    }
    return axios
      .delete(`/api/v1/files/${id}`)
      .then((res) => res.data)
      .then((data) => {
        this.setLoading(false);
        this.setState({ forceUpdateFiles: true }, () => {
          this.setState({ forceUpdateFiles: false });
        });
        this.getFiles();
      })
      .catch((err) => {
        this.setLoading(false);
      });
  }
  toggleUploadMode() {
    this.setState({ uploading: !this.state.uploading });
    setTimeout(() => {
      if (this._inp) {
        this._inp.nwdirectory = true;
        this._inp.directory = true;
        this._inp.webkitdirectory = true;
      }
    }, 500);
  }
  toggleShowMode(boolean) {
    this.setState({ show: boolean });
  }
  onCloseShowFolder() {
    this.setState({ showFolder: false, listFile: [] });
  }
  setLoading(loading) {
    this.setState({ loading });
  }

  valueRenderer(opt) {
    console.dir(opt);
  }
  onChangeFiles(e) {
    const titleEn = e.target.files[0].webkitRelativePath.split('/')[0];
    this.onFolderChoosen(e, titleEn);
  }
  renderUpload() {
    return (
      <div className="empty">
        {this.state.loading ? (
          <div className="loading">
            <Loading />
          </div>
        ) : (
          <div className="upload">
            <div className="upload-files">
              <h4>Upload Files</h4>
              <div className="upload-button ti-upload">
                <FileInput
                  name="file"
                  accept={FORMATS}
                  placeholder="My Image"
                  className="controller"
                  onChange={this.onFileChoosen}
                />
                <br />
                <div className="text-center-field">
                  <p>Supported {FORMATS}.</p>Number of lessons
                  <p> </p>
                  <p>Max File Size is {MAX_SIZE}mb</p>
                </div>
              </div>
            </div>
            <div className="upload-folder">
              <h4>Upload Folder</h4>
              <input
                ref={(i) => (this._inp = i)}
                onChange={this.onChangeFiles}
                type="file"
                directory=""
                webkitdirectory=""
                className="input-folder"
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  renderPreview() {
    let src = this.state.fileName;

    return (
      <div className={classNames('preview')} onClick={() => this.toggleUploadMode()}>
        {isEmpty(src) || src === 'null' ? (
          <div className="empty">
            <i className="ti-file" />
            <p>EMPTY</p>
          </div>
        ) : (
          renderFile(src)
        )}
      </div>
    );
  }

  getStateOptions() {
    return [SELECT_STATE, UPLOAD_STATE];
  }

  onActionChange(action) {
    if (action.value === 'select') {
      this.getFiles();
      this.getFolders();
      this.setState({ show: true });
    }
    this.setState({ action });
    this.toggleUploadMode();
  }

  fetchFiles(name) {
    const { onlyAudio } = this.props;
    const fetchUrl = onlyAudio
      ? `${AUDIO_FILES_API_URL}/${name}`
      : name
      ? `${FILES_API_URL}/${name}`
      : `${FILES_API_URL}`;
    this.setLoading(true);
    return axios
      .get(fetchUrl)
      .then((res) => res.data)
      .then((files) => {
        const listFile = files.map(({ Key, pretty, id }) => ({
          label: pretty,
          value: `${SERVER_URL}/${Key}`,
          id: id,
        }));
        this.setState({ files: listFile });
        this.setLoading(false);
      });
  }

  getFiles(query) {
    return this.fetchFiles(query).then((options) => {
      return { options };
    });
  }

  selectFile(item) {
    if (!item) return;

    const fileName = item.value;
    this.props.input.onChange(fileName);
    this.setState({ fileName: fileName });
  }

  renderValue({ label }) {
    if (isVideo(label)) {
      return (
        <div>
          <i className="ti-video-clapper" /> {label}
        </div>
      );
    }

    if (isAudio(label)) {
      return (
        <div>
          <i className="ti-music-alt" /> {label}
        </div>
      );
    }

    if (isPicture(label)) {
      return (
        <div>
          <i className="ti-image" /> {label}
        </div>
      );
    }

    return <b>{label}</b>;
  }

  renderOption({ value, label, id }) {
    if (isVideo(value)) {
      return (
        <div className="option-item">
          <i className="ti-video-clapper" />
          <div>
            <strong>{label}</strong>
          </div>
        </div>
      );
    }

    if (isAudio(value)) {
      return (
        <div className="option-item">
          <i className="ti-music-alt" />
          <div>
            <strong>{label}</strong>
          </div>
        </div>
      );
    }

    if (isPicture(value)) {
      return (
        <div className="option-item">
          <div className="image">
            <img className="preview-img-grid" src={value} width={50} />
            <div>
              <strong>{label}</strong>
            </div>
            <div
              id={'remove'}
              className="remove"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                this.onRemoveImage(id);
              }}
            >
              x
            </div>
          </div>
        </div>
      );
    }

    return <div />;
  }

  renderStateOption({ label, icon }) {
    return (
      <div>
        <i className={icon} /> {label}
      </div>
    );
  }

  render() {
    const {
      input: { value, onBlur = noop, onChange = noop },
      options,
      ...props
    } = this.props;

    const { action, fileName, loading, forceUpdateFiles, files, test, show } = this.state;

    let component = <div />;
    if (action && action === UPLOAD_STATE) {
      component = (
        <div
          className={classNames('file-upload-field', {
            small: this.props.small,
          })}
        >
          {this.isUploading() ? this.renderUpload() : this.renderPreview()}
        </div>
      );
    }

    if (action && action === SELECT_STATE) {
      component = (
        <div>
          <CustomSelect
            options={files}
            onRemoveImage={this.onRemoveImage}
            selectFile={this.selectFile}
            getFiles={this.getFiles}
            resetState={this.resetState}
            fileName={fileName}
            setFileName={this.resetState}
            folder={this.state.folder}
            getFoldersDetail={this.getFoldersDetail}
            showFolder={this.state.showFolder}
            listFile={this.state.listFile}
            onCloseShowFolder={this.onCloseShowFolder}
            deleteFolders={this.deleteFolders}
            createFolders={this.createFolders}
            updateFolder={this.updateFolder}
            updateNameFolder={this.updateNameFolder}
            toggleShowMode={this.toggleShowMode}
            show={show}
            loading={loading}
          />

          {/* <span className="Select-clear-zone" onClick={this.resetState}>
              <span className="Select-clear">×</span>
            </span> */}
          {/* </div> */}
          <br />
          <div
            className={classNames('file-upload-field', {
              small: this.props.small,
            })}
          >
            {this.renderPreview()}
          </div>
        </div>
      );
    }

    return (
      <div className="file">
        <ReactSelect
          value={action}
          options={this.getStateOptions()}
          onChange={this.onActionChange}
          searchable={false}
          optionRenderer={this.renderStateOption}
          valueRenderer={this.renderStateOption}
        />

        <div className="chooser">{component}</div>
      </div>
    );
  }
}

export default connect(
  (state) => ({}),
  (dispatch) =>
    bindActionCreators(
      {
        createElement,
      },
      dispatch
    )
)(FileUploadField);



// WEBPACK FOOTER //
// ./src/modules/Forms/FileUploadField/FileUploadField.js